const PROFILE_ENDPOINTS = {
  // Profile Details
  VIEWPROFILE: "/frontend/view-profile",
  LISTROLES: "/frontend/fetch-role",
  LISTEXPERIENCE: "/frontend/fetch-experience",
  LISTLOCATIONCHOICE: "/frontend/fetch-location",
  LISTSTATE: "/frontend/fetch-united-states",
  LISTCITY: "/frontend/city-names",
  UPDATEPROFILE: "/frontend/edit-profile",
  UPLOADCERTDOCUMENT: "/nurse/documents/upload",
};

export default PROFILE_ENDPOINTS;
